import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '../base-query';
import { serializeQueryArgs } from '../serialize-query-args';

export const BUSINESS_MANAGERS_TAGS = Object.freeze({
  INDEX: 'business_managers_index',
  OWNER: 'company_owner',
});

export const businessManagersApiSlice = createApi({
  tagTypes: Object.values(BUSINESS_MANAGERS_TAGS),
  reducerPath: 'businessManagersApiSlice',
  baseQuery,
  endpoints: (builder) => ({
    getBusinessManagers: builder.query({
      query: ({ apiManager, ...params }) => apiManager.getBusinessManagers(params),
      providesTags: [BUSINESS_MANAGERS_TAGS.INDEX],
    }),
    // Owner invite details, shown by the onboarding wizard. Shares the create
    // invalidation with the index so an owner invited from either screen shows on both.
    // `companyId` only keys the cache; the request is scoped by the company header.
    getCompanyOwner: builder.query({
      query: ({ apiManager }) => apiManager.getCompanyOwner(),
      transformResponse: (body) => body?.data ?? null,
      providesTags: [BUSINESS_MANAGERS_TAGS.OWNER],
    }),
    createBusinessManagers: builder.mutation({
      query: ({ apiManager, ...rest }) => apiManager.createBusinessManagers(rest),
      invalidatesTags: [BUSINESS_MANAGERS_TAGS.INDEX, BUSINESS_MANAGERS_TAGS.OWNER],
    }),
    updateBusinessManagers: builder.mutation({
      query: ({ apiManager, managerId, ...rest }) => apiManager.updateBusinessManagers(managerId, rest),
      invalidatesTags: [BUSINESS_MANAGERS_TAGS.INDEX],
    }),
    changeCompanyOwner: builder.mutation({
      query: ({ apiManager, ...rest }) => apiManager.changeCompanyOwner(rest),
      invalidatesTags: [BUSINESS_MANAGERS_TAGS.INDEX, BUSINESS_MANAGERS_TAGS.OWNER],
    }),
    deleteBusinessManagers: builder.mutation({
      query: ({ apiManager, managerId }) => apiManager.deleteBusinessManagers(managerId),
      invalidatesTags: [BUSINESS_MANAGERS_TAGS.INDEX],
    }),
  }),
  serializeQueryArgs,
});

export const {
  useGetBusinessManagersQuery,
  useGetCompanyOwnerQuery,
  useCreateBusinessManagersMutation,
  useChangeCompanyOwnerMutation,
  useDeleteBusinessManagersMutation,
  useUpdateBusinessManagersMutation,
} = businessManagersApiSlice;
